import { theme } from '../../styles/theme.css'
import { type CSSProperties, type ReactNode } from 'react'
import * as styles from './Text.css'

export interface FontProps {
  weight?: CSSProperties['fontWeight']
  size?: CSSProperties['fontSize']
  family?: CSSProperties['fontFamily']
  color?:
    | 'opaque'
    | 'primary'
    | 'secondary'
    | 'tertiary'
    | CSSProperties['color']
  fontStyle?: CSSProperties['fontStyle']
}

export interface TextProps
  extends Omit<React.HTMLAttributes<HTMLElement>, 'color'>,
    FontProps {
  hyphens?: boolean
  className?: string
  style?: CSSProperties
  maxLines?: number
  balance?: boolean
  align?: CSSProperties['textAlign']
  as?: keyof HTMLElementTagNameMap
  children?: ReactNode
}

/**
 * Renders text
 *
 * TODO:
 * - Add `TypoProvider` (makes it possible to set prop-default accross a whole tree)
 */
export default function Text({
  children,
  hyphens = false,
  className = '',
  family,
  size,
  weight,
  fontStyle,
  maxLines,
  color = 'primary',
  style = {},
  as: Tag = 'p',
  balance,
  align,
  ...props
}: TextProps) {
  let _color
  if (
    color === 'opaque' ||
    color === 'secondary' ||
    color === 'tertiary' ||
    color === 'brand' ||
    color === 'accent'
  ) {
    _color = theme.colors.text[color as keyof typeof theme.colors.text]
  } else if (color !== 'primary') {
    _color = color
  }

  return (
    <Tag
      {...props}
      style={
        {
          ...style,
          fontWeight: weight,
          fontSize: size,
          color: _color,
          fontFamily: family,
          fontStyle,
          textWrap: style.textWrap ?? (balance ? 'balance' : undefined),
          textAlign: align,
          '--max-lines': maxLines,
        } as CSSProperties
      }
      className={`${hyphens ? styles.hyphens : ''} ${className}`}
    >
      {children}
    </Tag>
  )
}
